import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Rocket, Sparkles, CheckCircle2, Crown } from "lucide-react";

interface PaywallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  usedCredits: number;
  maxCredits: number;
}

const PaywallDialog = ({ open, onOpenChange, usedCredits, maxCredits }: PaywallDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md border-primary/20">
        <DialogHeader className="text-center items-center">
          <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center mb-3 shadow-lg shadow-primary/20">
            <Crown className="h-8 w-8 text-primary-foreground" />
          </div>
          <DialogTitle className="text-2xl">Passez à la vitesse supérieure</DialogTitle>
          <DialogDescription className="text-base mt-2">
            Vous avez utilisé vos <span className="font-semibold text-primary">{maxCredits} modifications gratuites</span>.
            Débloquez des modifications illimitées avec Grafton Pro.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          {[
            "Modifications illimitées de votre site",
            "Templates premium exclusifs",
            "Nom de domaine personnalisé",
            "Support prioritaire Grafton IA",
            "Statistiques avancées",
          ].map((feature) => (
            <div key={feature} className="flex items-center gap-3">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0" />
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            variant="hero"
            size="lg"
            className="w-full h-12 text-base rounded-xl shadow-lg shadow-primary/20"
            onClick={() => window.open("https://grafton-starter.tiiny.site/", "_blank")}
          >
            <Rocket className="h-5 w-5 mr-2" />
            Mettre à niveau — Grafton Pro
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="text-muted-foreground"
            onClick={() => onOpenChange(false)}
          >
            Continuer en version gratuite
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaywallDialog;
